<script setup lang="ts">
import { ref, unref } from 'vue';

import type { ProbablyString } from '#public_ts/commons/fe-commons';

import { useExposeCustomModalDialogApi } from '../bootstrap-modal';
import BootstrapModal from '../bootstrap-modal.vue';
import type { ComboboxModalApi } from './combobox-modal';
import type { SelectType } from './radio-list';
import RadioListWithSearch from './radio-list-with-search.vue';

const props = defineProps<{
    name?: string;
    title?: string;
    type?: SelectType;
    withTitles?: boolean;
    withCustomValue?: boolean;
}>();

const modelValue = ref('');
const focus = ref(0);

const [apiExpose, apiRef] = useExposeCustomModalDialogApi<[ProbablyString], string>({
    onBeforeShow(value) {
        modelValue.value = value ?? '';
    },
    onBeforeSubmit() {
        const value = unref(modelValue);
        return value;
    },

});

defineExpose(apiExpose satisfies ComboboxModalApi);
</script>

<template>
    <BootstrapModal
        ref="apiRef"
        size="modal-fullscreen"
        :title="props.title"
        ok
        cancel
        close
        @dialog-opened="focus += 1"
    >
        <RadioListWithSearch
            v-model:model-value="modelValue"
            :name="props.name"
            :type="props.type"
            :with-titles="props.withTitles"
            :with-custom-value="props.withCustomValue"
            :focus="focus"
        />
    </BootstrapModal>
</template>
